import { subDays, format } from 'date-fns';
import type { Theme } from '@simplywallst/ui-core';
import { growthThreshold, daysBack } from '../constants';

export const getValidPrice = (
  date: number,
  entities: number[][],
  daysBack: number
): number | null => {
  const dateIndex = entities.findIndex(
    (entity) => format(entity[0], 'yyyyMMdd') === format(date, 'yyyyMMdd')
  );
  if (dateIndex !== -1) return entities[dateIndex][1];
  else {
    if (daysBack === 0) return null;
    else
      return getValidPrice(subDays(date, 1).getTime(), entities, daysBack - 1);
  }
};

export const getGrowthColor = (value: number, theme: Theme) => {
  if (value < 0) return theme.color.bad;
  if (value >= growthThreshold) return theme.color.good;
  return theme.color.whiteRGBA(0.7);
};

export const isPositiveMarker = (
  dispersion: number,
  dispersionThreshold: number,
  growth: number,
  growthThreshold: number,
  useNewFormula: boolean
) => {
  return useNewFormula
    ? growth >= growthThreshold && dispersion <= dispersionThreshold
    : growth >= growthThreshold;
};

export const getPriceGrowthData = (
  firstPrice: number | null,
  secondPrice: number,
  useNewFormula: boolean
) => {
  if (firstPrice === null) return { growth: 0, growthSign: '' };
  const growth = useNewFormula
    ? (1 / firstPrice) * secondPrice - 1
    : (secondPrice - firstPrice) / secondPrice;

  const growthSign = growth > 0 ? '+' : '';
  return { growth, growthSign };
};

export const getCurrentPrice = (date: number, priceData: number[][]) => {
  const today = new Date().getTime();
  return date <= today ? getValidPrice(date, priceData, daysBack) : null;
};
